import firebase from "firebase/app";
import { getUserId } from "src/config";
import firestore from "../firestore";
import { USER_PLAN as UserPlan } from "src/enums/common.enum";
import MonthYear from "../../interfaces/monthYear.interface";

export async function etsyRequestAuthorizationCode(args?: {
  back?: string;
  bankAccountId?: string | undefined;
  refresh_integration_id?: string;
}): Promise<{ data: { etsyURL: string } }> {
  const f = firebase.functions().httpsCallable("etsy-requestAuthorizationCode");
  return await f(args);
}

export async function etsyRequestAccessToken(args: {
  authorizationCode: string;
  state: string;
}) {
  const f = firebase.functions().httpsCallable("etsy-requestAccessToken");
  return await f(args);
}

export async function etsyDeleteIntegration(id?: string) {
  const f = firebase.functions().httpsCallable("etsy-deleteIntegration");
  // Without an id the backend drops every Etsy integration of the user, which
  // is what the no-shop reset wants and what clears a duplicated connection.
  return await f(id ? { integrationId: id } : {});
}

export async function etsyFetchListings() {
  const f = firebase.functions().httpsCallable("etsy-listingImport");
  return await f({});
}

export async function etsyFetchTransactions(start: MonthYear, end: MonthYear) {
  const f = firebase.functions().httpsCallable("etsy-transactionImport");
  return await f({
    start,
    end,
  });
}

export async function etsySyncApi(integrationId: string) {
  const f = firebase.functions().httpsCallable("etsy-syncNow");
  const result = await f({ integrationId });
  return result.data;
}

export async function getEtsyIntegration() {
  const uid = await getUserId();
  const db = firestore();
  const integrations = await db
    .collection("Plaid_Integrations")
    .where("user", "==", uid)
    .where("type", "==", "etsy")
    .get();
  const integration = integrations.docs.pop();
  if (integration) {
    return integration.data();
  } else {
    return null;
  }
}

export async function etsyIntegrationSyncChange(
  id: string,
  sync: boolean,
  inventory: boolean = true
) {
  const userId = await getUserId();
  const db = firestore();

  await db.runTransaction(async (transaction) => {
    const user = await transaction.get(db.collection("Users").doc(userId));
    await transaction.update(db.collection("Plaid_Integrations").doc(id), {
      sync: sync && user.data()?.plan === UserPlan.ULTIMATE,
      inventory: sync && inventory,
    });
  });
}
